//for that chat id whosent last msg

const ChatHistory=[
    {name:"Henrey B",time:"11:22 am",msg:"Message from Brad F",img:"face4",id:"2"},
    {name:"Jessie F",time:"1:42 am",msg:"Message from Jessie F",img:"face5",id:"4"},    
    {name:"Lina R",time:"1:30 am",msg:"Message from Brad F",img:"face3",id:"3"},
    {name:"Brad F",time:"12:42 am",msg:"Message from Brad F",img:"face7",id:"1"},
    {name:"Eliz F",time:"2:42 am",msg:"Message from Brad F",img:"face6",id:"5"},
];
export default ChatHistory;